export default __webpack_public_path__ + "static/media/goopter-popular-use-case-retail-stores.a4a41425.jpg";